var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPoubelle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22.9 24.4",
    style: {
      enableBackground: "new 0 0 22.9 24.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M21.9,3.1h-6.3l0-0.1c-0.7-1.6-2.3-2.6-4-2.6c-1.7,0-3.3,1-4,2.6l0,0.1H1.1c-0.5,0-0.8,0.4-0.8,0.8 s0.4,0.8,0.8,0.8h0.8v0.2l1,17.3C3,23.3,3.8,24,4.8,24h13.5c1,0,1.8-0.8,1.8-1.8l1-17.5l0.8,0c0.5,0,0.8-0.4,0.8-0.8 S22.3,3.1,21.9,3.1z M9.6,2.8c0.5-0.5,1.2-0.7,1.9-0.7s1.4,0.3,1.9,0.7l0.3,0.3H9.3L9.6,2.8z M18.4,22.4L4.6,22.3l-1-17.6h15.9 L18.4,22.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M7.7,20.4L7.7,20.4c0.3,0,0.5-0.1,0.6-0.3c0.1-0.2,0.2-0.4,0.2-0.6L7.9,7.6c0-0.2-0.1-0.4-0.3-0.6 C7.4,6.9,7.2,6.8,7.1,6.8c0,0,0,0-0.1,0c-0.2,0-0.4,0.1-0.6,0.3C6.3,7.2,6.2,7.5,6.2,7.7l0.7,11.9C6.9,20,7.3,20.4,7.7,20.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M15.2,20.4L15.2,20.4c0.5,0,0.8-0.3,0.9-0.8l0.7-11.9c0-0.2-0.1-0.4-0.2-0.6c-0.1-0.2-0.3-0.3-0.6-0.3 c-0.2,0-0.4,0.1-0.6,0.2c-0.2,0.1-0.3,0.4-0.3,0.6l-0.7,11.9c0,0.2,0.1,0.4,0.2,0.6C14.8,20.3,15,20.4,15.2,20.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M11.5,20.4c0.5,0,0.8-0.4,0.8-0.8V7.6c0-0.5-0.4-0.8-0.8-0.8s-0.8,0.4-0.8,0.8v11.9C10.7,20,11,20.4,11.5,20.4 z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoubelle);
export default __webpack_public_path__ + "static/media/Poubelle.68c49913.svg";
export { ForwardRef as ReactComponent };